import React from "react";
import ReactDOM from "react-dom";

import { Embed } from "components";
import { IEmbed } from "types";
import { EmbedBlockerContainer } from "./EmbedBlockerContainer";

const embedBlocks = document.querySelectorAll<HTMLElement>("[data-embed]");

embedBlocks.forEach((embedBlock) => {
  const embedInfo = embedBlock.dataset.embed;
  embedBlock.dataset.embed = ""; // cleanup

  if (!embedInfo) return;

  const embed: IEmbed = JSON.parse(embedInfo);

  if (embed.embed.includes("data-no-head-script")) return;

  ReactDOM.render(
    <EmbedBlockerContainer isSocialEmbed={embed.isSocialEmbed}>
      <Embed {...embed} blockElement={embedBlock.parentElement} />
    </EmbedBlockerContainer>,
    embedBlock
  );
});

export {};
